<template>
  <div class="w-full md:flex md:justify-center py-4 md:py-8">
    <section class="w-full max-w-7xl mx-auto px-5 py-2 md:px-4 2xl:p-0">
      <div
        class="w-full lg:w-[1150px] mx-auto flex flex-col gap-5 lg:flex-row md:gap-[30px] lg:gap-[70px]"
      >
        <h2
          class="block lg:hidden text-left font-semibold text-[24px] md:text-[28px] text-[#1f1f1f]"
        >
          Key Takeaways
        </h2>
        <p class="lg:hidden text-[14px] text-left">
          Become prominent in your area of expertise
        </p>
        <div class="hidden lg:block lg:w-[540px] lg:h-[490px]">
          <img
            src="@/assets/electiveListing/Key-takeaways-desktop.webp"
            alt=""
            class="w-full h-full rounded-3xl"
          />
        </div>
        <div class="lg:hidden flex items-center justify-center">
          <img
            src="@/assets/electiveListing/Key-takeaways-mobile.webp"
            alt=""
            class="w-full rounded-3xl md:w-[80%] object-contain"
          />
        </div>
        <div class="text-left">
          <h2 class="hidden lg:block text-[35px] text-[#1f1f1f] font-semibold">
            Key Takeaways
          </h2>
          <p class="hidden lg:block text-[18px]">
            Become prominent in your area of expertise
          </p>
          <div class="w-full pt-3 lg:w-[540px]">
            <ul
              v-for="(takeAways, index) in takeAwayList.takeaway"
              :key="index"
              class="list-disc flex flex-col gap-2 px-6"
            >
              <!-- <li>
                Earn a degree which empowers your career growth in the field of
                Finance
              </li>
              <li>
                Become proficient in both theoretical and practical concepts in
                Finance
              </li>
              <li>
                Attain expertise in making skilful financial decisions that
                generate optimum results
              </li>
              <li>
                Gain expertise in not only Finance, but also in leadership and
                team skills
              </li> -->
              <li class="text-[16px] md:text-[20px] text-[#1f1f1f]">
                {{ takeAways }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'KeyTakeaway',
  data() {
    return {
      takeAwayList: [],
    }
  },
  created() {
    this.KeyTakeAway()
  },
  methods: {
    async KeyTakeAway() {
      const slug = this.$route.params.slug
      const apiUrlTake = `${process.env.VUE_APP_API}/course/program-list/?slug=${slug}`
      await axios
        .get(apiUrlTake)
        .then((resp) => {
          // console.log(this.takeAwayList)

          if (resp.status == 200) {
            this.takeAwayList = resp.data.data[0]
          }
          console.log(this.takeAwayList)
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style></style>
